import { Component } from "@angular/core";
import { ApiService } from "src/app/api.service";

@Component({
	selector: "app-config-management",
	templateUrl: "./config-management.component.html",
	styleUrls: ["./config-management.component.scss"]
})
export class ConfigManagementComponent {
	constructor(public api: ApiService) { }
}
